/**
 * Reads the session the native app injects, instead of asking Auth0.
 */

export function isRunningInShell() {
  return typeof window !== 'undefined' && Boolean(window.__CASTME_SHELL__);
}

export function getShellSession() {
  const session = isRunningInShell() ? window.__CASTME_SESSION__ : undefined;

  if (!session || !session.idToken || !session.idTokenPayload) {
    return undefined;
  }

  if (session.expiresAt <= Date.now()) {
    return undefined;
  }

  return {
    idToken: session.idToken,
    accessToken: session.accessToken,
    idTokenPayload: session.idTokenPayload
  };
}

const SHELL_SESSION_EVENT = 'castme:session';
const SHELL_SESSION_WAIT_MS = 10000;

/**
 * Waits for the app's refreshed session. Back from the background the injected
 * one can be expired while the app is fetching the next, and asking Auth0 from
 * inside the app fails and signs chat out of Firebase.
 */
export function waitForShellSession() {
  return new Promise(resolve => {
    let timer;
    const finish = session => {
      clearTimeout(timer);
      window.removeEventListener(SHELL_SESSION_EVENT, onSession);
      resolve(session);
    };
    const onSession = () => {
      const session = getShellSession();
      if (session) finish(session);
    };
    timer = setTimeout(() => finish(undefined), SHELL_SESSION_WAIT_MS);

    window.addEventListener(SHELL_SESSION_EVENT, onSession);
    // In case the session arrived before the listener: no event would follow
    onSession();
  });
}
